import { PG_WEB_HOOK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Pg_Web_Hook = (payload) => {
    return apiInstance.post(PG_WEB_HOOK, payload);
};
